export const COMPANY = {
  name: 'OrionDev',
  tagline: 'Software engineering for organisations that depend on it',
  mission: 'We build dependable software for businesses, and invest in the next generation of engineers in underserved and rural communities.',
  description: `OrionDev is a software engineering company. We design, build and operate web platforms, mobile applications, integrations and cloud infrastructure for businesses across Africa and beyond — with one accountable team from scoping to support. Alongside client work, we invest in training young engineers from underserved and rural communities.`,
  contact: {
    email: 'hallo@oriondev.dev',
    phone: '+263771219727',
    location: 'Harare, Zimbabwe',
  },
  // Company profiles only. Leave a value empty to hide its icon in the footer.
  // TODO(owner): add the company's own pages once they exist.
  social: {
    github: '',
    linkedin: '',
    instagram: '',
  },
  values: [
    {
      title: 'Accountability',
      description: 'One team owns the outcome — scope, schedule, quality and support — with clear reporting at every stage.',
    },
    {
      title: 'Engineering discipline',
      description: 'Reviewed code, automated testing and documented architecture, so systems stay maintainable long after launch.',
    },
    {
      title: 'Lasting impact',
      description: 'Software that earns its keep for our clients, and skills that open careers in the communities we serve.',
    },
  ],
  // How clients can work with us — shown in the About section.
  engagements: [
    { title: 'Fixed-scope projects', detail: 'A defined deliverable, a fixed quotation, milestone billing.' },
    { title: 'Dedicated teams', detail: 'Engineers assigned to your roadmap on a monthly retainer.' },
    { title: 'Support & maintenance', detail: 'SLA-backed monitoring, fixes and upgrades after go-live.' },
  ],
  stats: {
    projectsDelivered: 55,
    clients: 30,
    yearsExperience: 8,
  },
  techCapabilities: {
    languages: ['Java', 'Kotlin', 'Dart', 'JavaScript', 'TypeScript', 'Go'],
    frameworks: ['Spring Boot', 'Ktor', 'Flutter', 'React', 'Next.js', 'Android', 'KMP'],
    infrastructure: ['PostgreSQL', 'MongoDB', 'Redis', 'Docker', 'Kafka', 'AWS', 'Firebase'],
  },
}
